import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';
import { RadioGroup, FormCheckConditional, DropdownInput, TextInput } from '../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const OccupationQuestion: React.StatelessComponent<Props> = props => {

	const isNextDisabled = function () {
		var valid = props.questionnaire.occupation !== undefined;
		if (props.questionnaire.occupation === 'Employed') {
			if (props.questionnaire.specificJob === undefined) {
				valid = false;
			}
			if (
				props.questionnaire.specificJob === 'occupationNoneOfTheAbove' &&
				props.questionnaire.jobDescription === undefined
			) {
				valid = false;
			}
		}
		if (props.questionnaire.occupation === 'Student') {
			if (props.questionnaire.fieldOfStudy === undefined) {
				valid = false;
			}
		}
		if (props.questionnaire.occupation === 'Unemployed') {
			if (props.questionnaire.reasonForUnemployment === undefined) {
				valid = false;
			}
			if (props.questionnaire.reasonForUnemployment === 'other' &&
				props.questionnaire.reasonForUnemploymentOtherValue === undefined) {
				valid = false;
			}
		}
		return !valid;
	};
	return (
		<div>
			<RadioGroup
				title={props.questions.occupation}
				name="occupation"
				radioOptions={[
					{
						id: 'occupationEmployed',
						label: `I'm employed`,
						value: 'Employed',
						checked: props.questionnaire.occupation === 'Employed',
						onBlur: props.onQuestionnaireBlur,
						onChange: props.onQuestionnaireChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire.occupation === 'Employed'} key="occupationEmployed">
								<RadioGroup
									title={props.questions.specificJob}
									name="specificJob"
									className={props.questionnaire.specificJob === 'occupationNoneOfTheAbove' ? '' : 'mb-2'}
									radioOptions={[
										{
											id: 'offshoreFisher',
											value: 'offshoreFisher',
											label: 'Offshore commercial fisher not coming ashore daily',
											checked: props.questionnaire.specificJob === 'offshoreFisher',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'steelErector',
											value: 'steelErector',
											label: 'Steel erector or scaffolder working at heights over 40 feet',
											checked: props.questionnaire.specificJob === 'steelErector',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'fallerOrLumberjack',
											value: 'fallerOrLumberjack',
											label: 'Faller or lumberjack',
											checked: props.questionnaire.specificJob === 'fallerOrLumberjack',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'offshoreDriller',
											value: 'offshoreDriller',
											label: 'Offshore driller',
											checked: props.questionnaire.specificJob === 'offshoreDriller',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'blaster',
											value: 'blaster',
											label: 'Blaster or explosive handler',
											checked: props.questionnaire.specificJob === 'blaster',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'occupationNoneOfTheAbove',
											value: 'occupationNoneOfTheAbove',
											label: 'None of the above',
											checked: props.questionnaire.specificJob === 'occupationNoneOfTheAbove',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										}
									]}
								/>
								{props.questionnaire.specificJob === 'occupationNoneOfTheAbove' && (
									<DropdownInput
										labelText={props.questions.jobDescription}
										name="jobDescription"
										value={props.questionnaire.jobDescription}
										onBlur={props.onQuestionnaireBlur}
										onChange={props.onQuestionnaireChange}
										defaultOption="-"
										options={[
											{
												value: 'Art, culture, recreation and sport',
												text: 'Art, culture, recreation and sport'
											},
											{
												value: 'Business, finance and administration',
												text: 'Business, finance and administration'
											},
											{
												value: 'Education, law and social, community and government services',
												text: 'Education, law and social, community and government services'
											},
											{
												value: 'Health',
												text: 'Health'
											},
											{
												value: 'Manufacturing and utilities',
												text: 'Manufacturing and utilities'
											},
											{
												value: 'Natural and applied sciences and related',
												text: 'Natural and applied sciences and related'
											},

											{
												value: 'Natural resources, agriculture and related production',
												text: 'Natural resources, agriculture and related production'
											},

											{
												value: 'Sales and service',
												text: 'Sales and service '
											},
											{
												value: 'Trades, transport and equipment operators and related',
												text: 'Trades, transport and equipment operators and related'
											},
											{
												value: 'Other',
												text: 'Other'
											}
										]}
										className="mb-2"
									/>
								)}
							</FormCheckConditional>
						)
					},
					{
						id: 'occupationStudent',
						label: `I'm a student`,
						value: 'Student',
						checked: props.questionnaire.occupation === 'Student',
						onBlur: props.onQuestionnaireBlur,
						onChange: props.onQuestionnaireChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire.occupation === 'Student'}>
								<DropdownInput
									labelText={props.questions.fieldOfStudy}
									name="fieldOfStudy"
									className="mb-2"
									value={props.questionnaire.fieldOfStudy}
									onBlur={props.onQuestionnaireBlur}
									onChange={props.onQuestionnaireChange}
									defaultOption="-"
									options={[
										{
											value: 'Arts and humanities',
											text: 'Arts and humanities'
										},
										{
											value: 'Business and administration',
											text: 'Business and administration'
										},
										{
											value: 'Education and teaching',
											text: 'Education and teaching'
										},
										{
											value: 'Engineering and engineering technology',
											text: 'Engineering and engineering technology'
										},
										{
											value: 'Health care',
											text: 'Health care'
										},
										{
											value: 'Legal professions and studies',
											text: 'Legal professions and studies'
										},
										{
											value: 'Mathematics and computer and information science',
											text: 'Mathematics and computer and information science'
										},
										{
											value: 'Mechanics and repair, architecture, construction and precision production',
											text: 'Mechanics and repair, architecture, construction and precision production'
										},
										{
											value: 'Science and science technology',
											text: 'Science and science technology'
										},
										{
											value: 'Social and behavioural sciences',
											text: 'Social and behavioural sciences'
										},
										{
											value: 'Other trades, services, natural resources and conservation',
											text: 'Other trades, services, natural resources and conservation'
										},
										{
											value: 'Other',
											text: 'Other'
										}
									]}
								/>
							</FormCheckConditional>
						)
					},
					{
						id: 'occupationUnemployed',
						label: `I'm unemployed`,
						value: 'Unemployed',
						checked: props.questionnaire.occupation === 'Unemployed',
						onBlur: props.onQuestionnaireBlur,
						onChange: props.onQuestionnaireChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire.occupation === 'Unemployed'}>
								<RadioGroup
									title={props.questions.reasonForUnemployment}
									name="reasonForUnemployment"
									className="mb-2"
									radioOptions={[
										{
											id: 'reasonForUnemploymentParent',
											label: `I'm a parent or caregiver`,
											value: 'parent',
											checked: props.questionnaire.reasonForUnemployment === 'parent',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'reasonForUnemploymentDisabled',
											label: `I'm on disability or medical leave`,
											value: 'disabledOrMedicalLeave',
											checked: props.questionnaire.reasonForUnemployment === 'disabledOrMedicalLeave',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'reasonForUnemploymentSocialAssistance',
											label: `I'm on social assistance`,
											value: 'socialAssistance',
											checked: props.questionnaire.reasonForUnemployment === 'socialAssistance',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'reasonForUnemploymentCannotFindWork',
											label: `I can't find work`,
											value: 'cannotFindWork',
											checked: props.questionnaire.reasonForUnemployment === 'cannotFindWork',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'reasonForUnemploymentRetired',
											label: `I'm retired`,
											value: 'retired',
											checked: props.questionnaire.reasonForUnemployment === 'retired',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange
										},
										{
											id: 'reasonForUnemploymentOther',
											label: `Other`,
											value: 'other',
											checked: props.questionnaire.reasonForUnemployment === 'other',
											onBlur: props.onQuestionnaireBlur,
											onChange: props.onQuestionnaireChange,
											conditionalChildren: (
												<FormCheckConditional
													contentClassName="mb-2"
													isOpen={props.questionnaire.reasonForUnemployment === 'other'}
												>
													<TextInput
														labelText="Please specify"
														name="reasonForUnemploymentOtherValue"
														value={props.questionnaire.reasonForUnemploymentOtherValue}
														onBlur={props.onQuestionnaireBlur}
														onChange={props.onQuestionnaireChange}
														className="mb-0"
													/>
												</FormCheckConditional>
											)
										}
									]}
								/>
							</FormCheckConditional>
						)
					}
				]}
			/>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default OccupationQuestion;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/lifestyleQuestions/occupationQuestion.tsx